<template>
    <div v-if="form">
        <div class="row q-col-gutter-md">
            <div class="col-12">
                <q-card>
                    <q-card-section class="q-pb-none">
                        <div class="row">
                            <div class="col">
                                <q-tabs
                                    v-model="tab"
                                    class="text-grey"
                                    active-color="primary"
                                    indicator-color="primary"
                                    align="left"
                                    narrow-indicator
                                >
                                    <q-tab name="general" label="Шаблон для поддоменов" />
                                    <q-tab name="main" label="Шаблон для основного домена" />
                                    <q-tab name="history" label="История изменений" />
                                </q-tabs>
                            </div>
                            <div v-if="editableTabs.indexOf(tab) !== -1" class="col text-right q-gutter-xs q-mb-md">
                                <a :href="url"><q-btn class="bg-white" label="Отмена"></q-btn></a>
                                <q-btn color="primary" label="Сохранить" @click="save"></q-btn>
                            </div>
                        </div>
                    </q-card-section>

                    <q-separator />

                    <q-tab-panels v-model="tab" animated>
                        <q-tab-panel name="general">
                            <div class="row q-col-gutter-md">
                                <div class="col-6">
                                    <q-input dense
                                             outlined
                                             v-model="form.name"
                                             label="Название"
                                             @input="form.errors.clear('name')"
                                             :error-message="form.errors.get('name')"
                                             :error="form.errors.has('name')"></q-input>

                                    <q-input dense
                                             outlined
                                             v-model="form.header"
                                             ref="header"
                                             type="textarea"
                                             label="Заголовок H1"
                                             @input="form.errors.clear('header')"
                                             :error-message="form.errors.get('header')"
                                             :error="form.errors.has('header')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="header" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <q-input dense
                                             outlined
                                             v-model="form.meta_title"
                                             ref="meta_title"
                                             type="textarea"
                                             label="Meta Title"
                                             @input="form.errors.clear('meta_title')"
                                             :error-message="form.errors.get('meta_title')"
                                             :error="form.errors.has('meta_title')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="meta_title" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <q-input dense
                                             outlined
                                             v-model="form.meta_description"
                                             ref="meta_description"
                                             type="textarea"
                                             label="Meta Description"
                                             @input="form.errors.clear('meta_description')"
                                             :error-message="form.errors.get('meta_description')"
                                             :error="form.errors.has('meta_description')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="meta_description" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <insert-menu :items="containers" :flat="false" color="primary" label="Выбрать параметр"></insert-menu>

                                    <q-editor placeholder="Description"
                                              @input="form.errors.clear('description')"
                                              min-height="5rem"
                                              :toolbar="toolbar"
                                              ref="description"
                                              v-model="form.description"
                                              :error-message="form.errors.get('description')"
                                              :error="form.errors.has('description')" ></q-editor>
                                </div>
                            </div>
                        </q-tab-panel>

                        <q-tab-panel name="main">
                            <div class="row q-col-gutter-md">
                                <div class="col-6">
                                    <q-input dense
                                             outlined
                                             v-model="form.main_header"
                                             ref="main_header"
                                             type="textarea"
                                             label="Заголовок H1"
                                             @input="form.errors.clear('main_header')"
                                             :error-message="form.errors.get('main_header')"
                                             :error="form.errors.has('main_header')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="main_header" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <q-input dense
                                             outlined
                                             v-model="form.main_meta_title"
                                             ref="main_meta_title"
                                             type="textarea"
                                             label="Meta Title"
                                             @input="form.errors.clear('main_meta_title')"
                                             :error-message="form.errors.get('main_meta_title')"
                                             :error="form.errors.has('main_meta_title')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="main_meta_title" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <q-input dense
                                             outlined
                                             v-model="form.main_meta_description"
                                             ref="main_meta_description"
                                             type="textarea"
                                             label="Meta Description"
                                             @input="form.errors.clear('main_meta_description')"
                                             :error-message="form.errors.get('main_meta_description')"
                                             :error="form.errors.has('main_meta_description')"
                                    >
                                        <template v-slot:append>
                                            <insert-menu field="main_meta_description" :items="containers" @select="putSelected"></insert-menu>
                                        </template>
                                    </q-input>

                                    <insert-menu :items="containers" :flat="false" color="primary" label="Выбрать параметр"></insert-menu>

                                    <q-editor placeholder="Description"
                                              @input="form.errors.clear('main_description')"
                                              min-height="5rem"
                                              :toolbar="toolbar"
                                              ref="main_description"
                                              v-model="form.main_description"
                                              :error-message="form.errors.get('main_description')"
                                              :error="form.errors.has('main_description')" ></q-editor>
                                </div>
                            </div>
                        </q-tab-panel>

                        <q-tab-panel name="history">
                            <history :path="`/admin-panel/content/templates/${id}/history`"></history>
                        </q-tab-panel>

                    </q-tab-panels>

                    <q-separator></q-separator>

                    <q-card-section v-if="editableTabs.indexOf(tab) !== -1" class="text-right">
                        <a :href="url"><q-btn class="bg-white" label="Отмена"></q-btn></a>
                        <q-btn color="primary" label="Сохранить" @click="save"></q-btn>
                    </q-card-section>
                </q-card>
            </div>
        </div>
    </div>
</template>

<script>
    import {Form} from "../../../classes/Form";
    import alert from '../../../mixins/alert';

    export default {
        name: 'Template',
        mixins: [
            alert,
        ],
        props: {
            id: {
                type: Number,
                required: false,
            }
        },
        data () {
            return {
                tagContainers: {
                    domain: {}
                },
                select: '',
                model: '',
                editor: '',
                selectContainers: [],
                tab: 'general',
                form: null,
                url: '/admin-panel/content/templates/',
                containers: [],
                caretStart: null,
                caretEnd: null,
                editableTabs: [
                    'general',
                    'main'
                ],
                template: {
                    id: null,
                    name: '',
                    header: '',
                    meta_title: '',
                    meta_description: '',
                    description: '',
                    main_header: '',
                    main_meta_title: '',
                    main_meta_description: '',
                    main_description: '',
                },
                toolbar: [
                    ['left', 'center', 'right', 'justify'],
                    ['bold', 'italic', 'strike', 'underline'],
                    [
                        {
                            label: this.$q.lang.editor.formatting,
                            icon: this.$q.iconSet.editor.formatting,
                            list: 'no-icons',
                            options: [
                                'p',
                                'h1',
                                'h2',
                                'h3',
                                'h4',
                                'h5',
                                'h6',
                                'code'
                            ]
                        },
                    ],
                    ['undo', 'redo'],
                    ['viewsource']
                ]
            }
        },
        mounted () {
            axios.get('')
                .then(response => {
                    if (response.data.status === 'success') {
                        this.containers = response.data.containers;

                        if (this.id) {
                            this.template = _.merge(this.template, response.data.template);
                        }
                        this.form = new Form(this.template);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        methods: {
            putSelected (field, value) {
                let _this = this;
                let input = _this.$refs[field].$refs.input;
                let text = _this.form[field].substring(0, input.selectionStart) + value + _this.form[field].substring(input.selectionEnd);

                text = text.replace(/ +(?= )/g,'');

                let position = input.selectionStart ? _this.form[field].substring(0, input.selectionStart).length : text.length;

                input.setSelectionRange(position, position);

                text = text.trim();

                _this.$set(_this.form, field, text);
                _this.form.errors.clear(field);
            },
            save () {
                let _this = this;

                _this.clearNotes();

                _this.form.submit(
                    _this.id ? 'put' : 'post',
                    _.trimEnd(_this.url, '/') + (_this.id ? '/' + _this.id : '')
                )
                    .then(response => {
                        _this.addResponseMessage(response);

                        if (response.redirect) {
                            window.location.href = response.redirect;
                        }
                    })
                    .catch(error => {
                        _this.addErrorMessage(error.message);
                    });
            },
        }
    }
</script>
